import { render, staticRenderFns } from "./HeaderCenter.vue?vue&type=template&id=1bb6631a&"
import script from "./HeaderCenter.vue?vue&type=script&lang=js&"
export * from "./HeaderCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports